<script>
  import AppHeader from './app/_default/components/Header.vue'
  import AppMenu from './app/_default/components/Menu.vue'
  import AppFooter from './app/_default/components/Footer.vue'
  import {mapState, mapGetters} from 'vuex'
  import Chat from './app/chat/components/Chat'
  import {isEmpty} from 'lodash'

  export default {
    name: 'app-root',
    components: { AppHeader, AppMenu, AppFooter, Chat },
    created () {
      this.$on('toggleChat', function () { console.log('emitiu') })
    },
    computed: {
      ...mapState({
        ...mapGetters(['currentUser', 'isLogged']),
        menuOpen: state => state.app.menuOpen,
        menuFolded: state => state.app.menuFolded,
        showMenu: state => state.app.showMenu,
        showHeader: state => state.app.showHeader,
        showFooter: state => state.app.showFooter,
        teste: isEmpty('Bola')
      })
    },
    methods: {
      toggleChat () {
        console.log('Toggle chat')
        this.$refs.chat.toggle()
      },
      updateNotReadedMessagesChat (data) {
        this.$refs.chat.updateNotReaded(data.mensagens)
      }
    }
  }
</script>

<template>
    <div v-if="isLogged" id="app" class="app app-aside-fixed " v-bind:class="{'s-menu': showMenu, 's-header': showHeader, 'app-aside-folded': menuFolded, 'app-header-fixed': showHeader}">
        <app-header @toggleChat="toggleChat" @updateNotReadedMessagesChat="updateNotReadedMessagesChat" v-if="showHeader"></app-header>
        <app-menu v-if="showMenu"></app-menu>
        <router-view></router-view>
        <!-- chat message -->
        <!--<chat ref="chat"></chat>-->
        <!-- / aside right chat -->
        <app-footer v-if="showFooter"></app-footer>
    </div>
  <div v-else>
    <router-view></router-view>
  </div>
</template>

<style src="./assets/scss/app.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// Root.vue?8ebfd6a2